/**
 * Reverses the boolean return value of the wrapped function
 */
export const negate =
  (func: (...args: any) => boolean): ((...args: any) => boolean) =>
  (...args: any) =>
    !func(...args);
